<template>
  <div class="dialog">
    <div class='h100vh-197 w100vw-284 h-scroll'>
      <ejs-grid ref="gnbPmDataQueryList" :allowPaging="false" :dataSource="dataSourceOfGnbPmDataQuery" :columns='columnsOfGnbPmDataQuery' :allowResizing='true' :height="screenHeight" :width="screenWidth" :dataBound="dataBound">
      </ejs-grid>
    </div>
    <div>
      <ejs-pager ref='pagerOfGnbPmDataQueryList' @click="getGnbPmDataQueryListData" :currentPage='page.currentPage' :pageCount='page.pageCount' :pageSize='page.pageSize' :totalRecordsCount='page.totalRecordsCount'></ejs-pager>
    </div>
  </div>
</template>

<script>

import DateUtil from "../util/DateUtil";
 import {EventBus} from "../../../../plugins/eventBus";

export default {
  name: 'ContentForGnbPmDataQueryRightList',
  props: [
    'dataLength'
  ],
  data() {
    return {
      dataSourceOfGnbPmDataQuery: [],
      columnsOfGnbPmDataQuery: [],
      screenHeight: 'calc(100vh - 236px)',
      screenWidth: '1462',
      page: {
        currentPage: 1,
        pageSize: 18,
        totalRecordsCount: 0,
        pageCount: 10
      },
    };
  },
  methods: {
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.gnbPmDataQueryList.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit("toast", {
          type: "warning",
          content: `${this.$t("Alarm.no_checked")}`
        });
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit("toast", {
          type: "warning",
          content: `${this.$t("Alarm.too_many_checked")}!`
        });
        return false;
      }
      return selectedRecords;
    },
    getGnbPmDataQueryListData(){
      this.$emit('gnbPmDataQueryListPageClick', this.$refs.pagerOfGnbPmDataQueryList.ej2Instances.currentPage);
    },

    dataBound() {
      let width = 820 + 300 * this.dataLength
      this.screenWidth = width < 1462 ? 1462 : width;
    },

    getColumnsOfGnbPmDataQuery(checkNodeList){
      this.columnsOfGnbPmDataQuery = [];
      const recoverStr = this.$t('MML.recover');
      const backupStr = this.$t('MML.backup');

      const columnsCacheOfOrdCommonAttr = [
        {field: 'EQUIPMENT_NAME',headerText: this.$t('MML.resourceCode'),textAlign: 'Center',clipMode: 'EllipsisWithTooltip',width: 100,autoFit: true},

        {
          field: 'TYPE',
          headerText: this.$t('MML.recoverOrBackup'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100,
          autoFit: true,
          valueAccessor: function valueAccessor (field,data){
            const type = parseInt(data[field]);
            if(type == 0){
             return recoverStr;

            } else{
               console.log('zz')

                return backupStr;
            }

          }
        },
        {
          field: 'URL',
          headerText: this.$t('MML.cfgPath'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100,
          autoFit: true
        },
        {
          field: 'CREATE_TIME',
          headerText: this.$t('MML.operateTime'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 150,
          autoFit: true,
          valueAccessor: function valueAccessor (field,data){
            return data[field].replace("T", " ").replace(/\+[0-9]{2}:[0-9]{2}$/g, '');
          }
        }
      ]

      for (let k = 0; k < columnsCacheOfOrdCommonAttr.length; k++) {
        this.columnsOfGnbPmDataQuery.push(columnsCacheOfOrdCommonAttr[k]);
      }

    }
  },
  mounted() {
  }
};
</script>

<style scoped>
  .dialog >>> .e-control.e-grid .e-gridcontent.e-lib.e-droppable {
    height: calc(100vh - 239px);
  }
</style>
